import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-permissions-edit',
	path: '/secure/admin/EditPermissions([!%]?[\\w]*).jspa',
};
